export default __webpack_public_path__ + "static/media/increase.11244837.svg";